import { ConfigEditor } from "./ConfigEditor.js";
import { ExecutionView } from "./ExecutionView.js";
import { Icon } from "./Icon.js";
import { configSchema, dataSchema, defaultConfig } from "./schema.js";
/**
 * Form Input action type plugin.
 *
 * Allows users to fill out a customizable form with various field types.
 */
export const inputFormPlugin = {
    slug: "input-form",
    name: "Form Input",
    description: "Collect user input via a customizable form",
    type: "input",
    completionType: "user_confirm",
    configSchema,
    dataSchema,
    defaultConfig,
    handlers: {
        onComplete: (ctx, data) => {
            ctx.logger.info("Form submitted", {
                actionId: ctx.execution.moduleActionId,
                userId: ctx.userId,
                fieldCount: Object.keys(data.formValues).length,
            });
            return Promise.resolve();
        },
    },
    components: {
        Icon,
        ConfigEditor,
        ExecutionView,
    },
    order: 1,
    version: "1.0.0",
    author: "Nucleus Team",
};
//# sourceMappingURL=index.js.map